import { render, staticRenderFns } from "./RssFeedList.vue?vue&type=template&id=dbbe8a80&scoped=true"
import script from "./RssFeedList.vue?vue&type=script&lang=js"
export * from "./RssFeedList.vue?vue&type=script&lang=js"
import style0 from "./RssFeedList.vue?vue&type=style&index=0&id=dbbe8a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbe8a80",
  null
  
)

export default component.exports